// images
import tr9 from "../../triangles/tr9.png"
import tr10 from "../../triangles/tr10.png"
import tr11 from "../../triangles/tr11.png"
import React from 'react';
import tr31 from "../../triangles/tr31.png"
import tr32 from "../../triangles/tr32.png"
import tr33 from "../../triangles/tr33.png"
import tr34 from "../../triangles/tr34.png"

import csi1 from "../../icons/cs1.png"
import csi2 from "../../icons/cs2.png"
import csi3 from "../../icons/cs3.png"
import csi4 from "../../icons/cs4.png"
// Imports 
import "./CaseStudy.scss"
import { Stack, Typography } from "@mui/material";
import { useEffect } from "react";



function CaseStudy() {

  useEffect(() => {
      window.scrollTo(0, 0);
  } , [])
  
  return (
    <div className="CaseStudy">
      <First />
      <Second />
      <Third />
      <Fourth />
      <Fifth />
    </div>
  );
}

function First() {

  if (localStorage.getItem("lang") === "en") {
    return (
      <div className="CsFirst">
  
        <img src={tr9} alt="" className="tr9" />
        <img src={tr10} alt="" className="tr10" />
        <img src={tr11} alt="" className="tr11" />
        
        <div className="container">
          <Typography color="secondary" sx={{
            fontWeight: "700",
            fontSize: {xs : "22px" , sm : "40px"},
            lineHeight: "50px",
            textAlign: "center",
            mb : {xs : 0 , sm : 8}
          }}>
            Here are some of our success stories
          </Typography>
          <Typography color="text.secondary" sx={{
            fontWeight: "400",
            fontSize: {xs : "16px" , sm : "20px"},
            lineHeight: "24px",
            display : "block",
            margin : "auto",
            maxWidth: "650px",
            textAlign: "center"
          }}>
            We always aim to ensure that our clients get the best results from their experience with Lean Finance to achieve their business objectives.
          </Typography>
        </div>
      </div>
    );
  } else {
    return (
      <div className="CsFirst">
  
        <img src={tr9} alt="" className="tr9" />
        <img src={tr10} alt="" className="tr10" />
        <img src={tr11} alt="" className="tr11" />
        
        <div className="container">
          <Typography color="secondary" sx={{
            fontWeight: "700",
            fontSize: {xs : "22px" , sm : "40px"},
            lineHeight: "50px",
            textAlign: "center",
            mb : {xs : 0 , sm : 8}
          }}>
            هنا بعض قصص نجاحنا
          </Typography>
          <Typography color="text.secondary" sx={{
            fontWeight: "400",
            fontSize: {xs : "16px" , sm : "22px"},
            lineHeight: "24px",
            display : "block",
            margin : "auto",
            maxWidth: "650px",
            textAlign: "center"
          }}>
            نحرص دائما إلى ضمان حصول عملائنا على أفضل النتائج أثناء استخدامهم برنامج لين فايننس لتحقيق أهداف أعمالهم.
          </Typography>
        </div>
      </div>
    );
  }
  
}

function Second() {
  if (localStorage.getItem("lang") === "en") {
    return (
      <div className="CsSecond" id="cs1">
        <img src={tr31} alt="" className="tr31" />
        <div className="header">
          <div className="container">
            <Stack spacing={4} direction="column-reverse" width="fit-content">
            <Typography sx={{
                py : 6 , 
                borderRadius : "10px" ,
                bgcolor : "primary.main",
                color : "white",
                textAlign : "center",
                fontSize : "18px"
  
              }}>Logistic Industry</Typography>
              <div className="image"><img src={csi1} alt="" /></div>
            </Stack>
          </div>
        </div>
        <div className="container">
          <Stack direction={{xs : "column" , md: "row"}} spacing={{xs: 10 , sm : 20 , md: 60}}>
  
            <Stack direction="column" spacing={{xs: 10 , sm: 60}} pr={{xs: 0 , sm: 60}} borderRight="1px solid" borderColor={{xs : "transparent" , md : "text.secondary"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  About
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "290px"
                }}>
                  The One Logistics is a company specializing in moving exotic luxury vehicles around the world by Sea, Air & Road.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  Challenge
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "320px"
                }}>
                  The main problem faced was handling and organizing the mountain of hardcopy invoices, having a clear overview of the revenues generated and the ability to easily share invoices with clients.
                </Typography>
              </Stack>
            </Stack>
  
            <Stack>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                Solution
              </Typography>
              <Stack spacing={{xs: 10 , sm: 60}} direction={{xs : "column" , sm : "row"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Digitalization
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "290px",
                    mb : {xs : 10 , sm : 36}
                  }}>
                    With Lean Finance they are able to digitalize their entire invoicing process, allowing for an organized, efficient and easily accessibly financial data.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Dashboard
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px"
                  }}>
                    By using the dashboard view they are able to quickly gain access to all info and revenues generated at a glance.
                  </Typography>
                </Stack>
                <Stack>
                  <Typography color="secondary" sx={{
                      fontSize : "20px",
                      fontWeight : "700",
                      lineHeight : "24px",
                      mb : 4
                    }}>
                      Sharing
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px",
                  }}>
                    And by using the simple sharing features they are able to instantly share invoice with clients and make sure to get paid faster. 
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
  
          </Stack>
        </div>
      </div>
    );
  } else {
    return (
      <div className="CsSecond" id="cs1">
        <img src={tr31} alt="" className="tr31" />
        <div className="header">
          <div className="container">
            <Stack spacing={4} direction="column-reverse" width="fit-content">
            <Typography sx={{
                py : 6 , 
                borderRadius : "10px" ,
                bgcolor : "primary.main",
                color : "white",
                textAlign : "center",
                fontSize : "18px"
  
              }}>القطاع الوجستي</Typography>
              <div className="image"><img src={csi1} alt="" /></div>
            </Stack>
          </div>
        </div>
        <div className="container">
          <Stack direction={{xs : "column" , md: "row"}} spacing={{xs: 10 , sm : 20 , md: 60}}>
  
            <Stack direction="column" spacing={{xs: 10 , sm: 60}} pr={{xs: 0 , sm: 60}} borderRight="1px solid" borderColor={{xs : "transparent" , md : "text.secondary"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  عن الشركة
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "290px"
                }}>
                  اللوجستي الاول هي شركة متخصصة في نقل المركبات الفاخرة والفريدة حول العالم عن طريق البحر والجو والبر.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  التحدي
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "320px"
                }}>
                  كانت المشكلة الرئيسية التي تمت مواجهتها هي التعامل مع جبل الفواتير الورقية وتنظيمها، والحصول على نظرة عامة واضحة على الإيرادات المحققة والقدرة على مشاركة الفواتير بسهولة مع العملاء.
                </Typography>
              </Stack>
            </Stack>
  
            <Stack>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                الحل
              </Typography>
              <Stack spacing={{xs: 10 , sm: 60}} direction={{xs : "column" , sm : "row"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    ترقيم
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "290px",
                    mb : {xs : 10 , sm : 36}
                  }}>
                    باستخدام لين فايننس ، فهم قادرون على رقمنة عملية الفوترة بأكملها ، مما يساعد على تقديم بيانات مالية منظمة وفعالة ويسهل الوصول إليها.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    لوحة التحكم
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px"
                  }}>
                    باستخدام عرض لوحة التحكم الرئيسية ، يمكنهم الوصول بسرعة إلى جميع المعلومات والإيرادات الناتجة في لمح البصر.
                  </Typography>
                </Stack>
                <Stack>
                  <Typography color="secondary" sx={{
                      fontSize : "20px",
                      fontWeight : "700",
                      lineHeight : "24px",
                      mb : 4
                    }}>
                      المشاركة
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px",
                  }}>
                    وباستخدام ميزات المشاركة البسيطة ، يمكنهم مشاركة الفاتورة مع العملاء على الفور والتأكد من حصولهم على الدفعات بشكل أسرع.
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
  
          </Stack>
        </div>
      </div>
    );
  }
}

function Third() {
  if(localStorage.getItem("lang") === "en") {
    return (
      <div className="CsSecond CsThird" id="cs2">
        <img src={tr32} alt="" className="tr32" />
        <div className="header">
          <div className="container">
              <Stack spacing={4} direction="column-reverse" width="fit-content">
                <Typography sx={{
                  py : 6 , 
                  borderRadius : "10px" ,
                  bgcolor : "primary.main",
                  color : "white",
                  textAlign : "center",
                  fontSize : "18px"
  
                }}>Real Estate Industry</Typography>
                <div className="image"><img src={csi2} alt="" /></div>
              </Stack>
            </div>
        </div>
        <div className="container">
          <Stack direction={{xs: "column", sm : "row"}} spacing={{xs : 20 , sm : 0}} >
            <Stack flex="1" spacing={{xs : 20 , sm : 60}} borderRight="1px solid" borderColor={{xs : "transparent", sm : "text.secondary"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : 8
                }}>
                  About
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "420px"
                }}>
                  Eskan Salman are a real estate developer and financier for those looking to buy or rent.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : 8
                }}>
                  Challenge
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "480px"
                }}>
                  They had challenges in handling hardcopy invoices so needed to shift to an online e-invoice solution, their original invoicing process was inefficient and they had issues granting multiple users different access permissions to manage their roles.
                </Typography>
              </Stack>
            </Stack>
            <Stack flex="1" pl={{xs : 0 , sm : 60}}>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                Solution
              </Typography>
              <Stack spacing={60} direction="row">
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Fast & Simple
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    // maxWidth : "470px",
                    mb : {xs : 20 , sm : 50}
                  }}>
                    They were able to easily learn how to use Lean Finance that let them digitize and manage their invoices in a very simple and fast way, helping in creating a better invoicing experience for their clients.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Collaboration
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    // maxWidth : "470px"
                  }}>
                    To support their finance team they were able to give different individuals certain permissions to perform their tasks and in turn significantly improved the efficiency of their process. 
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </div>
      </div>
    );
  } else {
    return (
      <div className="CsSecond CsThird" id="cs2">
        <img src={tr32} alt="" className="tr32" />
        <div className="header">
          <div className="container">
              <Stack spacing={4} direction="column-reverse" width="fit-content">
                <Typography sx={{
                  py : 6 , 
                  borderRadius : "10px" ,
                  bgcolor : "primary.main",
                  color : "white",
                  textAlign : "center",
                  fontSize : "18px"
  
                }}>قطاع العقارات</Typography>
                <div className="image"><img src={csi2} alt="" /></div>
              </Stack>
            </div>
        </div>
        <div className="container">
          <Stack direction={{xs: "column", sm : "row"}} spacing={{xs : 20 , sm : 0}} >
            <Stack flex="1" spacing={{xs : 20 , sm : 60}} borderRight="1px solid" borderColor={{xs : "transparent", sm : "text.secondary"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : 8
                }}>
                  عن الشركة
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "420px"
                }}>
                  إسكان سلمان مطور عقاري وممول لمن يتطلعون للشراء أو الإيجار.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : 8
                }}>
                  التحدي
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "480px"
                }}>
                  واجهوا تحديات في التعامل مع الفواتير الورقية مما كان بالضرورة التحول إلى حل الفاتورة الإلكترونية عبر الإنترنت، وكانت عملية الفوترة الأصلية الخاصة بهم غير فعالة، وكانوا يعانو من منح صلاحيات الدخول المختلفة لمستخدمين متعددين لإدارة أدوارهم
                </Typography>
              </Stack>
            </Stack>
            <Stack flex="1" pl={{xs : 0 , sm : 60}}>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                الحل
              </Typography>
              <Stack spacing={60} direction="row">
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    سريع وبسيط
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    // maxWidth : "470px",
                    mb : {xs : 20 , sm : 50}
                  }}>
                    لقد كانوا قادرين على تعلم كيفية استخدام لين فايننس بسهولة مما أتاح لهم رقمنة وإدارة فواتيرهم بطريقة بسيطة وسريعة للغاية ، مما ساهم في تقديم تجربة فواتير أفضل لعملائهم.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    تعاون
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    // maxWidth : "470px"
                  }}>
                    لدعم فريقهم المالي ، كانوا قادرين على منح أفراد مختلفين صلاحيات محددة لأداء مهامهم وبالتالي تحسين كفاءة العملية بشكل كبير.
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </div>
      </div>
    );
  }
}

function Fourth() {
  if(localStorage.getItem("lang") === "en") {
    return (
      <div className="CsSecond CsFourth" id="cs3">
        <img src={tr33} alt="" className="tr33" />
        <div className="header">
          <div className="container">
            <Stack spacing={4} direction="column-reverse" width="fit-content">
              <Typography sx={{
                py : 6 , 
                borderRadius : "10px" ,
                bgcolor : "primary.main",
                color : "white",
                textAlign : "center",
                fontSize : "18px"
  
              }}>قطاع التعليم</Typography>
              <div className="image"><img src={csi3} alt="" /></div>
            </Stack>
          </div>
        </div>
        <div className="container">
          <Stack direction={{xs : "column" , md: "row"}} spacing={{xs: 10 , sm : 20 , md: 60}}>
  
            <Stack direction="column" spacing={{xs: 10 , sm: 60}} pr={{xs: 0 , sm: 60}} borderRight="1px solid" borderColor={{xs : "transparent" , md : "text.secondary"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  About
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "290px"
                }}>
                  A school for elementary, middle and high school students aiming to raise the educational efficiency of the teacher and student through the application of modern strategies in learning.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  Challenge
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "320px"
                }}>
                  Due to the number of students, the finance department had issues in keeping all invoices organized and on time. Hardcopy invoices made it more difficult to share them with parents as they had to visit the school.
                </Typography>
              </Stack>
            </Stack>
  
            <Stack>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                Solution
              </Typography>
              <Stack spacing={{xs: 10 , sm: 60}} direction={{xs : "column" , sm : "row"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Management
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "290px",
                    mb : {xs : 10 , sm : 36}
                  }}>
                    Lean Finance enabled them to transform their hardcopy invoicing process into an online e-invoicing process that simplified the management and filing of all documents for faster access times.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Automation
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px"
                  }}>
                    With Lean Finance they are able to schedule their invoices to automatically issue them periodically without missing any days.
                  </Typography>
                </Stack>
                <Stack>
                  <Typography color="secondary" sx={{
                      fontSize : "20px",
                      fontWeight : "700",
                      lineHeight : "24px",
                      mb : 4
                    }}>
                      Sharing
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px",
                  }}>
                    With the simple sharing features they were able to instantly send invoices and receipts to parents without needing them to come visit the school.
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
  
          </Stack>
        </div>
      </div>
    );
  } else {
    return (
      <div className="CsSecond CsFourth" id="cs3">
        <img src={tr33} alt="" className="tr33" />
        <div className="header">
          <div className="container">
            <Stack spacing={4} direction="column-reverse" width="fit-content">
              <Typography sx={{
                py : 6 , 
                borderRadius : "10px" ,
                bgcolor : "primary.main",
                color : "white",
                textAlign : "center",
                fontSize : "18px"
  
              }}>قطاع التعليم</Typography>
              <div className="image"><img src={csi3} alt="" /></div>
            </Stack>
          </div>
        </div>
        <div className="container">
          <Stack direction={{xs : "column" , md: "row"}} spacing={{xs: 10 , sm : 20 , md: 60}}>
  
            <Stack direction="column" spacing={{xs: 10 , sm: 60}} pr={{xs: 0 , sm: 60}} borderRight="1px solid" borderColor={{xs : "transparent" , md : "text.secondary"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  عن الشركة
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "290px"
                }}>
                  مدرسة لطلاب المدارس الابتدائية والمتوسطة والثانوية تهدف إلى رفع الكفاءة التعليمية للمعلم والطالب من خلال تطبيق الاستراتيجيات الحديثة في التعلم.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  التحدي
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "320px"
                }}>
                  نظرًا لعدد الطلاب الكبير ، واجه قسم الشؤون المالية مشكلات في تنظيم جميع الفواتير واصدارها في الوقت المحدد.
                  الفواتير المطبوعة جعلت من الصعب مشاركتها مع أولياء الأمور حيث كان لزاماً عليهم زيارة المدرسة.
                </Typography>
              </Stack>
            </Stack>
  
            <Stack>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                الحل
              </Typography>
              <Stack spacing={{xs: 10 , sm: 60}} direction={{xs : "column" , sm : "row"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    الإدارة
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "290px",
                    mb : {xs : 10 , sm : 36}
                  }}>
                    مكنهم لين فايننس من تحويل عملية الفوترة الورقية إلى عملية فواتير إلكترونية عبر الإنترنت، سهّلت إدارة وحفظ جميع الفواتير لأوقات وصول أسرع.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    التشغيل الآلي
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px"
                  }}>
                    باستخدامهم لين فايننس، أمكنهم من جدولة فواتيرهم لإصدارها تلقائيًا بشكل دوري دون أن يفوتهم أي يوم.
                  </Typography>
                </Stack>
                <Stack>
                  <Typography color="secondary" sx={{
                      fontSize : "20px",
                      fontWeight : "700",
                      lineHeight : "24px",
                      mb : 4
                    }}>
                      المشاركة
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px",
                  }}>
                    من خلال ميزات المشاركة البسيطة ، تمكنوا من إرسال الفواتير والمستندات على الفور إلى أولياء الأمور دون الحاجة إلى زيارتهم للمدرسة.
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
  
          </Stack>
        </div>
      </div>
    );
  }
}

function Fifth() {
  if (localStorage.getItem("lang") === "en") {
    return (
      <div className="CsSecond CsFifth" id="cs4">
        <img src={tr34} alt="" className="tr34" />
        <div className="header">
          <div className="container">
            <Stack spacing={4} direction="column-reverse" width="fit-content">
              <Typography sx={{
                py : 6 , 
                borderRadius : "10px" ,
                bgcolor : "primary.main",
                color : "white",
                textAlign : "center",
                fontSize : "18px"
  
              }}>Entertainment Industry</Typography>
              <div className="image"><img src={csi4} alt="" /></div>
            </Stack>
          </div>
        </div>
        <div className="container">
          <Stack direction={{xs : "column" , md: "row"}} spacing={{xs: 10 , sm : 20 , md: 60}}>
  
            <Stack direction="column" spacing={{xs: 10 , sm: 60}} pr={{xs: 0 , sm: 60}} borderRight="1px solid" borderColor={{xs : "transparent" , md : "text.secondary"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  About 
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "290px"
                }}>
                  Production studio providing Saudi TV channels with news, reports and documentaries from around the world.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  Challenge
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "320px"
                }}>
                  Due to the nature of the business they needed to have flexibility in customizing their invoices, be able to digitalize their process and easily issue ZATCA compliant e-invoices.
                </Typography>
              </Stack>
            </Stack>
  
            <Stack>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                Solution
              </Typography>
              <Stack spacing={{xs: 10 , sm: 60}} direction={{xs : "column" , sm : "row"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Customization
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "290px",
                    mb : {xs : 10 , sm : 36}
                  }}>
                    With Lean Finance they are able to easily customize the fields and info needed to be readily available for the finance team.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    Compliance
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px"
                  }}>
                    Lean Finance simplified the issuance of ZATCA approved invoices and automated it for their customers.
                  </Typography>
                </Stack>
                <Stack>
                  <Typography color="secondary" sx={{
                      fontSize : "20px",
                      fontWeight : "700",
                      lineHeight : "24px",
                      mb : 4
                    }}>
                      Digitalization
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px",
                  }}>
                    By digitalizing their invoicing process they helped their finance team speed up the work process and improve efficiency.
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
  
          </Stack>
        </div>
      </div>
    );
  } else {
    return (
      <div className="CsSecond CsFifth" id="cs4">
        <img src={tr34} alt="" className="tr34" />
        <div className="header">
          <div className="container">
            <Stack spacing={4} direction="column-reverse" width="fit-content">
              <Typography sx={{
                py : 6 , 
                borderRadius : "10px" ,
                bgcolor : "primary.main",
                color : "white",
                textAlign : "center",
                fontSize : "18px"
  
              }}>قطاع الترفية</Typography>
              <div className="image"><img src={csi4} alt="" /></div>
            </Stack>
          </div>
        </div>
        <div className="container">
          <Stack direction={{xs : "column" , md: "row"}} spacing={{xs: 10 , sm : 20 , md: 60}}>
  
            <Stack direction="column" spacing={{xs: 10 , sm: 60}} pr={{xs: 0 , sm: 60}} borderRight="1px solid" borderColor={{xs : "transparent" , md : "text.secondary"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
              <Stack>
                <Typography color="text.secondary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  عن الشركة
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "290px"
                }}>
                  استوديو إنتاج يزود القنوات التلفزيونية السعودية بالأخبار والتقارير والأفلام الوثائقية من جميع أنحاء العالم.
                </Typography>
              </Stack>
              <Stack>
                <Typography color="primary" sx={{
                  fontSize : "28px",
                  fontWeight : "700",
                  lineHeight : "34px",
                  mb : {xs : 4 ,sm :8}
                }}>
                  التحدي
                </Typography>
                <Typography color="text.secondary" sx={{
                  fontSize : "22px",
                  fontWeight : "400",
                  lineHeight : "26px",
                  maxWidth : "320px"
                }}>
                  نظرًا لطبيعة العمل الذي يحتاجون إليه ، يجب أن يتمتعوا بالمرونة في تخصيص فواتيرهم ، وأن يكونوا قادرين على رقمنة عملياتهم وإصدار فواتير إلكترونية متوافقة مع هيئة الزكاة والضريبة والجمارك بسهولة.
                </Typography>
              </Stack>
            </Stack>
  
            <Stack>
              <Typography color="secondary" sx={{
                fontSize : "28px",
                fontWeight : "700",
                lineHeight : "34px",
                mb : 10
              }}>
                الحل
              </Typography>
              <Stack spacing={{xs: 10 , sm: 60}} direction={{xs : "column" , sm : "row"}} justifyContent={{xs:"space-between" , sm : "flex-start"}}>
                <Stack>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    التخصيص
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "290px",
                    mb : {xs : 10 , sm : 36}
                  }}>
                    باستخدام لين فايننس ، يمكنهم تخصيص الحقول والمعلومات اللازمة بكل سهولة لتكون متاحة  لفريق الشؤون المالية.
                  </Typography>
                  <Typography color="secondary" sx={{
                    fontSize : "20px",
                    fontWeight : "700",
                    lineHeight : "24px",
                    mb : 4
                  }}>
                    معتمد
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px"
                  }}>
                    باستخدام لين فايننس أصبح بإمكانهم تبسيط وإصدار الفواتير المعتمدة من هئية الزكاة والضريبة والجمارك وأتمتتها لعملائها.
                  </Typography>
                </Stack>
                <Stack>
                  <Typography color="secondary" sx={{
                      fontSize : "20px",
                      fontWeight : "700",
                      lineHeight : "24px",
                      mb : 4
                    }}>
                      الرقمنة
                  </Typography>
                  <Typography sx={{
                    fontSize : "20px",
                    fontWeight : "400",
                    lineHeight : "24px",
                    maxWidth : "280px",
                  }}>
                    من خلال رقمنة عملية الفواتير الخاصة بهم ، ساعدوا فريقهم المالي على تسريع العمليات وتحسين الكفاءة.
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
  
          </Stack>
        </div>
      </div>
    );
  }
}

export default CaseStudy;